/* Seed Cube inline search. Uses Shopify predictive search + the theme's search-results section markup. */
(function () {
  'use strict';
  if (window.__scInlineSearch) return;
  window.__scInlineSearch = true;

  var MIN_CHARS = 2;
  var DEBOUNCE = 250;
  var route = (window.theme && theme.routes && theme.routes.predictiveSearch) || '/search/suggest';

  function init(form) {
    var input = form.querySelector('.sc-isearch__input');
    var results = form.querySelector('[data-sc-search-results]');
    if (!input || !results) return;
    var timer = null;
    var ctrl = null;
    var lastTerm = '';

    function open() {
      if (!results.innerHTML) return;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      form.classList.add('is-open');
    }
    function close() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      form.classList.remove('is-open');
    }

    function fetchResults(term) {
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var params = 'q=' + encodeURIComponent(term) +
        '&' + encodeURIComponent('resources[limit]') + '=3' +
        '&' + encodeURIComponent('resources[limit_scope]') + '=each' +
        '&' + encodeURIComponent('resources[options][unavailable_products]') + '=last' +
        '&section_id=search-results';
      fetch(route + '?' + params, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (text) {
          if (input.value.trim() !== term) return;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var sec = doc.querySelector('#shopify-section-search-results');
          if (!sec) { close(); return; }
          /* Avoid a duplicate id with the theme's own (empty) results container */
          var dup = sec.querySelector('#predictive-search-results');
          if (dup) dup.removeAttribute('id');
          results.innerHTML = sec.innerHTML;
          open();
          if (window.AOS && typeof AOS.refreshHard === 'function') AOS.refreshHard();
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < MIN_CHARS) { lastTerm = ''; results.innerHTML = ''; close(); return; }
      timer = setTimeout(function () {
        if (term === lastTerm && results.innerHTML) { open(); return; }
        lastTerm = term;
        fetchResults(term);
      }, DEBOUNCE);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS) open();
    });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); }
    });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });

    /* Keyboard users tabbing away. relatedTarget is null on touch taps, so tapping a result is never cut off. */
    form.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !form.contains(e.relatedTarget)) close();
    });
  }

  function visibleInput() {
    var list = document.querySelectorAll('[data-sc-search] .sc-isearch__input');
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) return list[i];
    }
    return null;
  }

  /* Desktop: the search icon opens a slim bar under the header instead of the theme overlay.
     Mobile/tablet: the icon focuses the always-visible green bar. */
  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var lastTrigger = null;

  function strip() { return document.getElementById('ScDesktopSearch'); }

  function openStrip(trigger) {
    var s = strip();
    if (!s) return;
    lastTrigger = trigger || null;
    s.hidden = false;
    if (lastTrigger) lastTrigger.setAttribute('aria-expanded', 'true');
    var input = s.querySelector('.sc-isearch__input');
    if (input) input.focus();
  }

  function closeStrip(returnFocus) {
    var s = strip();
    if (!s || s.hidden) return;
    var results = s.querySelector('[data-sc-search-results]');
    if (results) results.hidden = true;
    var input = s.querySelector('.sc-isearch__input');
    if (input) input.setAttribute('aria-expanded', 'false');
    s.hidden = true;
    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) { var t = lastTrigger; setTimeout(function () { t.focus(); }, 0); }
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.js-search-header');
    var s = strip();

    if (trigger) {
      if (s && mqDesktop.matches) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (s.hidden) openStrip(trigger); else closeStrip(false);
        return;
      }
      var target = visibleInput();
      if (!target) return; /* nothing inline visible: let the theme overlay run as normal */
      e.preventDefault();
      e.stopImmediatePropagation();
      target.focus();
      return;
    }

    if (s && !s.hidden && !s.contains(e.target)) closeStrip(false);
  }, true);

  document.addEventListener('keydown', function (e) {
    var s = strip();
    if (e.key === 'Escape' && s && !s.hidden) closeStrip(true);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sc-dsearch-close]')) closeStrip(true);
  });

  function boot() {
    var forms = document.querySelectorAll('[data-sc-search]');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();